.container {
  user-select: none;
  position: relative;
  display: flex;
  max-width: 32rem;
  min-width: 25.6rem;
  width: 100%;
  cursor: pointer;
  height: 3.2rem;
  align-items: center;
  z-index: 1;
  padding: 0.7rem 0.8rem;
  border-radius: var(--border-radius-medium);
  background: var(--bg-elevation-1);

  &[data-active='true'] {
    border: 1px #367bff solid;
  }
}

.header {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.stage-number {
  font-size: 1.4rem;
  color: #1f2023;
  border-radius: 0.4rem;
  background-color: var(--white-default);
  margin-right: 0.8rem;
  padding: 0.1rem 0.4rem;
  font-weight: 600;
}

.title {
  display: flex;
  flex-direction: row;
  align-items: center;

  h3 {
    color: var(--text-color-white);
    font-weight: 400;
    font-size: 1.4rem;
  }
}

.header-progress {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.4rem;
}

.progress-indicator {
  font-size: 1.4rem;
  color: #8a8f98;

  span {
    color: var(--text-color-white);
  }
}
